import React from "react"
import "./topbar.css"
// import { NotificationsNone, Language, Settings } from "@material-ui/icons"
import { useSelector } from "react-redux"

export default function Topbar() {
  const currentUser = useSelector((store) => store.user.currentUser)
  return (
    <div className='topbar'>
      <div className='topbarWrapper'>
        <div className='topLeft'>
          <span className='logo'>Dashboard</span>
        </div>
        <div className='topRight'>
          {/* <div className='topbarIconContainer'>
            <NotificationsNone />
            <span className='topIconBadge'>2</span>
          </div>
          <div className='topbarIconContainer'>
            <Language />
            <span className='topIconBadge'>2</span>
          </div>
          <div className='topbarIconContainer'>
            <Settings />
          </div> */}
          <img src={currentUser.image} alt='' className='topAvatar' />
        </div>
      </div>
    </div>
  )
}
